import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ImgView from 'components/common/FileController/ImgView';
import { Tabs } from 'antd';

@inject('commonStore','companyStore')
@observer
class CompanyContainer extends Component {
  
  UNSAFE_componentWillMount() {
    this.props.companyStore.setCommonStoreInfo(this.props.commonStore);
    this.props.companyStore.onClear();
    this.props.companyStore.disCompanyList('T', 'Y');
  }

  render() {
    const { companyList } = this.props.companyStore;
    return (
      <Fragment>
        <Tabs type="card">
        {companyList !== undefined && companyList !== null && companyList.map((item, idx)=>{
          return(
          <Tabs.TabPane tab={item.cpTabNm} key={item.cpTabCd} forceRender>
            <ImgView
              fileInfo={item.cpImgInfo}
              width={'100%'}
              height={'100%'}
            />
          </Tabs.TabPane>
          )
        })}
        </Tabs>    
      </Fragment>
    );
  }

}

export default withRouter(CompanyContainer);
